import { createContext, useContext } from 'react';

/**
 * SourceLinkContext is provided by each ContentBlock to give SourceTrackingLink
 * access to the store, turn identity, and URL context map without window globals.
 */
const SourceLinkContext = createContext(null);

export const useSourceLinkContext = () => useContext(SourceLinkContext);

export default SourceLinkContext;